import { createEditButton } from '../../../../components'
import { UpsertAuthorizationEventResolutionModal } from '../UpsertAuthorizationEventResolution/UpsertAuthorizationEventResolutionModal'

export const AuthorizationEventResolutionEditButton = createEditButton(
  UpsertAuthorizationEventResolutionModal,
  'authorization_event_resolutions'
)
